import { NameId } from "@common/types/NameId";
import { TFunction } from "next-i18next";

enum DealTypeEnum {
  Wholesale = 1,
  Retail = 2,
  Aftermarket = 4,
  C2CFinancing = 5,
  BuyIn = 6,
}

export const dealTypes: NameId[] = [
  {
    name: "Wholesale",
    id: DealTypeEnum.Wholesale.toString(),
  },
  {
    name: "Retail",
    id: DealTypeEnum.Retail.toString(),
  },
  {
    name: "Aftermarket",
    id: DealTypeEnum.Aftermarket.toString(),
  },
  {
    name: "C2C Financing",
    id: DealTypeEnum.C2CFinancing.toString(),
  },
  {
    name: "Buy-In",
    id: DealTypeEnum.BuyIn.toString(),
  },
].sort((a, b) => a.name.localeCompare(b.name));

export function getDealTypeFilters(
  t: TFunction,
  showAllTypes: boolean,
  adminDealTypes?: NameId[]
): NameId[] {
  return [
    {
      name: t("wholesale", { ns: "common" }),
      id: DealTypeEnum.Wholesale.toString(),
    },
    {
      name: t("retail", { ns: "common" }),
      id: DealTypeEnum.Retail.toString(),
    },
    {
      name: t("aftermarket", { ns: "admin" }),
      id: DealTypeEnum.Aftermarket.toString(),
    },
    {
      name: t("c2c", { ns: "admin" }),
      id: DealTypeEnum.C2CFinancing.toString(),
    },
    {
      name: t("buy_in", { ns: "admin" }),
      id: DealTypeEnum.BuyIn.toString(),
    },
  ]
    .filter(
      (dt) =>
        showAllTypes || adminDealTypes?.map((udt) => udt.id).includes(dt.id)
    )
    .sort((a, b) => a.name.localeCompare(b.name));
}

export const getDealTypeById = (id: string): NameId | undefined =>
  dealTypes.find((dt) => dt.id === id);

export default DealTypeEnum;
